import api from "../../../core/api";
import { Page } from "../../models/models";
import {
  AppNotification,
  NotificationHistoryQuery,
} from "../models/notificationModels";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.notificationsApiBaseUrl };
};

class NotificationsApi {
  getNotifications(
    pageNo: number = 1,
    pageSize: number = 20
  ): Promise<AppNotification[]> {
    return api
      .get("/v1/customer/notifications", {
        ...getRequestConfig(),
        params: { pageNo, pageSize },
      })
      .then((x) => x.data);
  }

  getUnreadCount(): Promise<number> {
    return api
      .get<number>("/v1/customer/notifications/unread-count", getRequestConfig())
      .then((x) => x.data);
  }

  markAsRead(notificationId: string): Promise<void> {
    return api
      .post<void>(
        `/v1/customer/notifications/${notificationId}/read`,
        null,
        getRequestConfig()
      )
      .then((x) => x.data);
  }

  markAllAsRead(): Promise<void> {
    return api
      .post<void>(
        "/v1/customer/notifications/read-all",
        null,
        getRequestConfig()
      )
      .then((x) => x.data);
  }

  deleteNotification(notificationId: string): Promise<void> {
    return api
      .delete<void>(
        `/v1/customer/notifications/${notificationId}`,
        getRequestConfig()
      )
      .then((x) => x.data);
  }

  searchNotifications(
    query: NotificationHistoryQuery
  ): Promise<Page<AppNotification>> {
    const params: Record<string, unknown> = {
      pageNo: query.pageNo,
      pageSize: query.pageSize,
      sortDesc: query.sortDesc ?? true,
    };
    if (query.search) params.search = query.search;
    if (query.eventTypes && query.eventTypes.length > 0)
      params.eventTypes = query.eventTypes.join(",");
    if (query.readFilter === "unread") params.isRead = false;
    if (query.readFilter === "read") params.isRead = true;
    if (query.dateFrom) params.dateFrom = query.dateFrom;
    if (query.dateTo) params.dateTo = query.dateTo;

    return api
      .get("/v1/customer/notifications/search", {
        ...getRequestConfig(),
        params,
      })
      .then((x) => x.data);
  }
}

export default new NotificationsApi();
